import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {NgbDropdownModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import { NgApexchartsModule } from 'ng-apexcharts';
import { SimplebarAngularModule } from 'simplebar-angular';

// components
import { StatisticsComponent } from './statistics/statistics.component';
import { PreloaderComponent } from './preloader/preloader.component';
import { RecentActivityComponent } from './recent-activity/recent-activity.component';
import { CardTitleComponent } from './card-title/card-title.component';


@NgModule({
  declarations: [
    StatisticsComponent,
    PreloaderComponent,
    RecentActivityComponent,
    CardTitleComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    NgbDropdownModule,
    NgbTooltipModule,
    SimplebarAngularModule,
    NgApexchartsModule
  ],
  exports: [
    StatisticsComponent,
    PreloaderComponent,
    RecentActivityComponent,
    CardTitleComponent,
    NgApexchartsModule,
  ],
})
export class WidgetModule { }
